module.exports = __webpack_public_path__ + "static/media/SendConfirmation.4f9a532b.svg";